let audioContext = null;
let placementBuffer = null;

function soundEnabled() {
  return document.documentElement.dataset.moveSoundEnabled !== 'false';
}

function ensureAudioContext() {
  if (audioContext) return audioContext;
  const AudioContextType = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextType) return null;
  audioContext = new AudioContextType({ latencyHint: 'interactive' });
  return audioContext;
}

function bufferFor(context) {
  if (placementBuffer?.sampleRate === context.sampleRate) return placementBuffer;
  const duration = 0.075;
  const length = Math.max(1, Math.floor(context.sampleRate * duration));
  const buffer = context.createBuffer(1, length, context.sampleRate);
  const samples = buffer.getChannelData(0);
  let seed = 0x51f15e;
  for (let index = 0; index < length; index += 1) {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    const noise = ((seed / 0xffffffff) * 2) - 1;
    const time = index / context.sampleRate;
    const envelope = Math.exp(-time * 54);
    const wood = Math.sin(2 * Math.PI * 185 * time)
      + (0.42 * Math.sin(2 * Math.PI * 420 * time));
    samples[index] = Math.max(-1, Math.min(1, (wood * 0.34 + noise * 0.22) * envelope));
  }
  placementBuffer = buffer;
  return buffer;
}

function playNow(context) {
  const source = context.createBufferSource();
  const filter = context.createBiquadFilter();
  const gain = context.createGain();
  source.buffer = bufferFor(context);
  filter.type = 'lowpass';
  filter.frequency.value = 1250;
  filter.Q.value = 0.55;
  gain.gain.value = 0.48;
  source.connect(filter).connect(gain).connect(context.destination);
  source.start();
}

export function playMoveFeedback() {
  if (!soundEnabled()) return;
  const context = ensureAudioContext();
  if (!context) return;
  if (context.state === 'suspended') {
    void context.resume().then(() => playNow(context)).catch(() => {});
    return;
  }
  playNow(context);
}

// Browsers require audio to be unlocked by a user gesture. Capturing the first
// pointer interaction once keeps later opponent moves audible without adding
// page-specific listeners.
document.addEventListener('pointerdown', () => {
  if (!soundEnabled()) return;
  const context = ensureAudioContext();
  if (context?.state === 'suspended') void context.resume().catch(() => {});
}, { capture: true, once: true, passive: true });
